"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const optional = { optional: true };
/**
 * @category High Order Guard
 * @description
 * This returns a contextual guard that allows keyed High Order Guards, I.E: TupleOf, that the key might not be present.
 * @return a `OptionalGuard` of the same type as the guard passed
 * @example
 * ```typescript
 *   const isOptionalAge = OptionalOf(isNumber);
 *   const isPersonTuple: Guard<[string, number?]> = TupleOf([isString, isOptionalAge]);
 * ```
 */
const OptionalOf = (guard) => {
    return Object.assign((v) => guard(v), optional);
};
exports.default = OptionalOf;
